import {RouteComponentProps} from 'react-router-dom';
import React, {useEffect, useState} from "react";
import './ArticleDetailPage.scss'
import ArticleApi from "../../api/ArticleApi";
import Article from "../../api/model/Article";
import MarkdownRender from "../../components/shared/MarkdownRender/MarkdownRender";

export default function ArticleDetailPage(props: IProps) {
    const id = props.match.params.id;
    const [article, setArticle] = useState<Article | undefined>();

    async function fetchData() {
        setArticle(await ArticleApi.queryById({
            id: Number(id)
        }));
    }

    function navigateToMainPage() {
        props.history.push('/')
    }

    function navigateToListPage() {
        props.history.push('/article/' + article?.type)
    }

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <div className="ArticleDetailPage">
             <span className="breadcrumbs">
                 <span style={{fontSize: 13}} onClick={() => {navigateToMainPage()}}>主页 / </span>
                 <span style={{fontSize: 13}} onClick={() => {navigateToListPage()}}>{article?.type} / </span>
                 文章详情
             </span>

            <div className="title">
                {article?.title}
            </div>
            <div className="subtitle">
                发布版块: <span onClick={() => {
                navigateToListPage()
            }}>{article?.type}</span>
                &nbsp;&nbsp;
                发布时间：{article?.createdTime}
            </div>

            <div className="content">
                {
                    article &&
                    <MarkdownRender md={article.content || ""}/>
                }
            </div>
        </div>
    )
}

interface IProps extends RouteComponentProps<IParams> {

}

interface IParams {
    id: string
}
